import { makeStyles } from '@material-ui/styles';
import { Theme } from '@material-ui/core/styles';
import { iron, mediumCarmine, orange, orangered } from 'styles/abstract/variables';
import { Block } from '@material-ui/icons';

const backgroundImage = `linear-gradient(136deg, ${orange} 0%,
    ${orangered} 50%, ${mediumCarmine} 100%)`;

export const makeColorlibStepIconStyles = makeStyles(
    (theme: Theme) => ({
        root: {
            alignItems: 'center',
            backgroundColor: iron,
            borderRadius: '50%',
            display: 'flex',
            height: 56,
            justifyContent: 'center',
            width: 56,

            '& img': {
                maxWidth: '80%',
            },

            [theme.breakpoints.down('xs')]: {
                height: 50,
                width: 50,
            },
        },
        active: {
            backgroundImage,
            boxShadow: '0 4px 5px 0 rgba(0, 0, 0, 0.25)',
        },
        completed: {
            backgroundImage,
        },
    }),
    { index: 1 },
);

export const makeStepConnectorClasses = makeStyles(
    {
        alternativeLabel: {
            top: 26,
        },
        active: {
            '& $line::before': {
                backgroundImage,
                width: '100%',
            },
        },
        completed: {
            '& $line::before': {
                backgroundImage,
                width: '100%',
            },
        },
        line: {
            backgroundColor: iron,
            border: 0,
            borderRadius: 1,
            height: 3,
            position: 'relative',
            zIndex: -1,

            '&::before': {
                content: '""',
                backgroundImage,
                border: 0,
                borderRadius: 1,
                display: 'block',
                height: 3,
                transition: 'all 0.3s ease',
                width: '0%',
            },
        },
    },
    { index: 1 },
);

export const makeStepLabelClasses = makeStyles(
    (theme: Theme) => ({
        stepContainer: {
            flex: '1 0 calc(25% - 10px)'
        },
        labelContainerDesktop: {
            [theme.breakpoints.down('xs')]: {
                display: 'none',
            },
        },
        labelContainerMobile: {
            display: 'none',
            [theme.breakpoints.down('xs')]: {
                display: 'block',
                marginTop: 10,
                padding: '10px 0',
                borderTop: `1px solid ${iron}`,
                borderBottom: `1px solid ${iron}`,
            },
        },
    }),
    { index: 1 },
);

export const makeStepperClasses = makeStyles(
    (theme: Theme) => ({
        root: {
            background: 'transparent',

            [theme.breakpoints.down('xs')]: {
                padding: theme.spacing(3, 0),
                flexWrap: 'wrap',
                paddingBottom: 0
            },
        },
    }),
    { index: 1 },
);

export const makeTitleClasses = makeStyles(
    (theme: Theme) => ({
        root: {
            fontSize: '1rem',
            fontWeight: 600,
            transition: 'all 0.3s ease',
        },
        colorPrimary: {
            color: 'inherit',
        },
        colorSecondary: {
            color: orangered,
        },
    }),
    { index: 1 },
);
